import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainView from './views/main';
import AssetDetails from './tabs/assetDetails';
import InspectionDetails from './tabs/inspectionDetails';

const EvirPxRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<MainView />} />
      <Route path="/:tabId" element={<MainView />} />
      <Route path="/asset-details/:assetId" element={<AssetDetails />} />
      <Route path="/inspection-details/:inspectionId" element={<InspectionDetails />} />
    </Routes>
  );
};

export default EvirPxRouter;
